import { render } from "./InterlinearWidget.vue?vue&type=template&id=4edadb90&scoped=true"
import script from "./InterlinearWidget.vue?vue&type=script&lang=js"
export * from "./InterlinearWidget.vue?vue&type=script&lang=js"

import "./InterlinearWidget.vue?vue&type=style&index=0&id=4edadb90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edadb90"]])

export default __exports__